<template>
  <div class="sorted-item bg-gray-600">
    <div class="grid rounded-[6px] grid-cols-[152px_1fr_128px]">
      <!-- 拖拽圖標和序號 -->
      <div class='p-2 flex justify-between items-center'>
        <img src="../../images/icons/sortable_icon.svg" 
             class="w-8 h-8 object-contain sortable-handle cursor-move"/>
        <div>{{ index }}</div>
        
        <!-- Collection 縮圖（使用第一個 post 的圖片） -->
        <div class="w-[72px] h-[72px] rounded-8px overflow-hidden relative">
          <img :src="collectionCoverImage" :alt="item.title" />
        </div>
      </div>

      <!-- 信息區域 -->
      <div class='py-2'>
        <div class="flex flex-col h-full pr-3 break-word justify-between">
          <!-- 標題 -->
          <div class="post_title text-14px font-medium hover:underline">
            <a :href="collectionUrl">{{ item.title }}</a>
          </div>

          <!-- Collection 特有信息 -->
          <div class="collection-info text-12px text-grey-5">
            <div class="privacy">
              {{ $t('public_profiles.type') }}: 
              {{ item.is_public ? $t('public_profiles.public') : $t('public_profiles.private') }}
            </div>
          </div>
        </div>
      </div>

      <!-- 操作按鈕（Collection 只有移動按鈕，沒有 Pin） -->
      <sorted-action-buttons
        order-type="custom_order"
        :show-pin-icon="false"
        :is-pinned="false"
        @move-to-top="handleMoveToTop"
        @move-to-bottom="handleMoveToBottom"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue';
import { useSortableItem } from '../utils/useSortableItem.js';

export default defineComponent({
  name: 'CollectionSortItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    isSortable: {
      type: Boolean,
      default: true
    }
  },
  emits: ['moveToTop', 'moveToBottom'],
  
  setup(props, { emit }) {
    const {
      handleMoveToTop,
      handleMoveToBottom,
    } = useSortableItem(props, emit);

    // Collection 封面圖片（使用第一個 post 的圖片或預設圖片）
    const collectionCoverImage = computed(() => {
      return props.item.preview_posts?.[0]?.cover_image_src;
    });

    // Collection URL
    const collectionUrl = computed(() => {
      const currentPath = window.location.pathname;
      const username = currentPath.match(/\/p\/([^\/]+)\//)?.[1];
      return `/p/${username}/collections/${props.item.id}`;
    });

    return {
      collectionCoverImage,
      collectionUrl,
      handleMoveToTop,
      handleMoveToBottom,
    };
  }
});
</script>